<template>
  <div>
    <MasterDetail
      formTitle="Cadastro de Instituições"
      :cols="cols"
      :opts="opts"
      :customResource="customResource"
      descriptionProperty="razao_social"
      :hasExportCSV="false"
      :hasExportXLSX="false"
      serverPagination
      cancelButtonTextOnly
    >
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <div class="table-v-action-button mr-3" v-bind="attrs" v-on="on">
            <v-icon>mdi-file-delimited-outline</v-icon>
            Exportações
          </div>
        </template>
        <v-list>
          <v-list-item>
            <v-list-item-title class="table-v-action-button" @click="exportCsv()">
              <v-icon>mdi-file-delimited</v-icon>
              XLSX Assíncrono
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </MasterDetail>
    <v-dialog v-model="exportacaoAsyncDialog" scrollable persistent max-width="400">
      <v-card>
        <v-card-title style="display: block" class="pb-1">
          <v-icon x-large class="mr-3">mdi-file-delimited-outline</v-icon>
          Exportar Relatório
          <v-btn @click="exportacaoAsyncDialog = false" style="position: absolute; right: 5px; top: 5px" icon>
            <v-icon>mdi-close-circle-outline</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <p>Requisição entrou na fila para processamento.</p>
          <p>Para ver o progresso e baixar o relatório, veja a fila.</p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="px-6 pb-3 pt-0">
          <v-spacer></v-spacer>
          <v-btn color="primary" class="pr-5" dark depressed @click="exportacaoAsyncDialog = false">
            <v-icon left>mdi-chevron-left</v-icon> Fechar
          </v-btn>
          <v-btn color="primary" dark depressed class="px-5 ml-3" @click="verFila()">
            Ver fila
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import MasterDetail from "@/components/master-detail.vue";
import ictClientesService from "@/api/ict/ictClientes.service";

export default {
  components: {
    MasterDetail,
  },
  computed: {
    empresaId() {
      return this.$store.getters.clientId;
    },
    customResource() {
      const empresaId = this.empresaId;
      return {
        get: (params) => ictClientesService.getAll(empresaId, params),
        save: (data, id) => {
          const promise = id
            ? ictClientesService.update(empresaId, id, data)
            : ictClientesService.create(empresaId, data);
          return promise.catch(e => ({ error: e.response?.data?.message || "Falha ao salvar cliente." }));
        },
        delete: (id) => {
          return ictClientesService.delete(empresaId, id)
            .catch(e => ({ error: e.response?.data?.message || "Falha ao excluir cliente." }));
        },
      };
    },
  },
  data() {
    return {
      exportacaoAsyncDialog: false,
      cols: [
        {
          key: "id",
          name: "ID",
          hideInform: true,
        },
        {
          key: "razao_social",
          name: "Razão Social",
          type: this.$fieldTypes.TEXT,
          colSize: 12,
          rules: [{ rule: "required" }],
          filterable: true,
        },
        {
          key: "cnpj",
          name: "CNPJ",
          type: this.$fieldTypes.CNPJ,
          colSize: 12,
          mask: "##.###.###/####-##",
          rules: [{ rule: "required" }],
          filterable: true,
        },
        {
          key: "criado_em",
          name: "Criado Em",
          type: this.$fieldTypes.DATETIME,
          hideInform: true,
        },
        {
          key: "modificado_em",
          name: "Modificado Em",
          type: this.$fieldTypes.DATETIME,
          hideInform: true,
        },
      ],
      opts: {},
    };
  },
  methods: {
    confirmDeleteMessage({ razao_social }) {
      return `Deseja realmente deletar o cliente <b>"${razao_social}"</b>?`;
    },
    exportCsv: function () {
      const md = this.$children.find(c => c.$options.name === 'MasterDetail');
      const filters = md ? md.pageTableFilters : {};

      this.apiResource(`v1/clientes/${this.empresaId}/exportacao`)
        .save({
          tipoRelatorio: "ict-clientes",
          filters: JSON.stringify(filters)
        })
        .then(() => {
          this.exportacaoAsyncDialog = true;
        });
    },
    verFila: function () {
      this.$router.push({
        path: "/clientes/dashboard/relatorios-exportados",
      });
    },
  },
};
</script>
